import React, { PureComponent } from 'react';

class MobileButtons extends PureComponent {
    render() {
        const { toggleShare, isShareOpen, isKeyOpen, toggleKey} = this.props;
        return (
            <div className="mobilebuttons">
                <div className="row no-gutters">
                    <div className="col-6">
                        <div className={ isKeyOpen ? "mobilebuttons-button __key __active" : "mobilebuttons-button __key"} onClick={toggleKey}>What do the icons mean?</div>
                    </div>
                    <div className="col-6">
                        <div className={isShareOpen ? "mobilebuttons-button __share __active" : "mobilebuttons-button __share"} onClick={() => toggleShare()}></div>
                    </div>
                </div>
            </div>
        )
    }
}

export default MobileButtons;


// WEBPACK FOOTER //
// ./src/Results/MobileButtons.js